import { useState } from 'react';
import { Button, Modal, Box, CircularProgress, Typography, Grid, Autocomplete, Select, MenuItem, Checkbox, TextField } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import { axiosInstance } from 'utils/axios';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const InsertDepositRecord = ({ customerLoginUserNames, status, thirdPartyIDs, fetchdepositRecord }) => {
    const token = useSelector(selectCurrentToken);
    const [DepositData, setDepositData] = useState([{ thirdPartyID: '', amount: '' }]);

    const handleAddRow = () => {
        setDepositData([...DepositData, { thirdPartyID: '', amount: '' }]);
    };

    const removeRow = (index) => {
        const updatedSales = DepositData.filter((_, i) => i !== index);
        setDepositData(updatedSales);
    };

    const handleInputChange = (index, field, value) => {
        const updatedSales = [...DepositData];
        updatedSales[index][field] = value;
        setDepositData(updatedSales);
    };

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [clientNames, setclientNames] = useState('');
    const [customerLoginUserName, setCustomerLoginUserName] = useState('');
    const [statusID, setStatusID] = useState('');
    const [thirdPartyID, setThirdPartyID] = useState('');
    const [amount, setamount] = useState(1);
    const [updateActive, setupdateActive] = useState(false);
    const [transactionNumber, setTransactionNumber] = useState('');

    const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);
    const [insertTasklistLoading, setInsertTasklistLoading] = useState(false);

    const insertAddress = async () => {
        setInsertBtnDisabled(true);
        setTimeout(() => {
            setInsertBtnDisabled(false);
        }, 3000);
        setInsertTasklistLoading(true);
        console.log("dist doesn't ran");
        try {
            const validDepositData = DepositData.filter(
                (item) => item.thirdPartyID !== "" && item.amount !== ""
            );
    
            // if (validDepositData.length === 0) {
            //     errorAlert("Please select a third party and enter the amount.");
            //     setUpdatedepositListLoading(false);
            //     return;
            // }
    
            const res = await axiosInstance.post(
                '/Deposit',
                {
                    customerLoginUserName: customerLoginUserName,
                    statusID: statusID,
                    amount: amount,
                    thirdPartyID: thirdPartyID,
                    transactionNumber: transactionNumber,
                    salesAmountByThirdParty: validDepositData.map((item) => ({
                        thirdPartyID: parseInt(item.thirdPartyID),
                        amount: parseFloat(item.amount),
                    })),
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Deposit Inserted successfully.');
                fetchdepositRecord();
                clearInput();
            } 
            else if (res.response.status === 400){
                errorAlert(res.response.data?.errorMessage);
            }
            else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setInsertTasklistLoading(false);
        }
    };

    const clearInput = () => {
        setCustomerLoginUserName('');
        setStatusID(''); 
        setThirdPartyID(''); 
        setamount(0); 
        setTransactionNumber('');
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: deepPurple[500],
                    color: 'white',
                    marginLeft: 'auto',
                    marginBottom: '20px',
                    marginRight: '20px'
                }}
            >
                Insert Deposit
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {insertTasklistLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Insert Deposit
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Customer Login User Name :
                                        </Typography>
                                        <Autocomplete
                                            freeSolo
                                            value={customerLoginUserName}
                                            onChange={(event, newValue) => {
                                                setCustomerLoginUserName(newValue);
                                            }}
                                            inputValue={customerLoginUserName}
                                            onInputChange={(event, newInputValue) => {
                                                setCustomerLoginUserName(newInputValue);
                                            }}
                                            id="controllable-states-demo"
                                            options={customerLoginUserNames}
                                            sx={{ width: 170 }}
                                            renderInput={(params) => <TextField {...params} />}
                                            disableClearable
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Deposit Status :
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            value={statusID}
                                            onChange={(e) => setStatusID(e.target.value)}
                                            // sx={{width:"100%"}}
                                        >
                                            <MenuItem value="">Select Status</MenuItem>
                                            {status.map((item, index) => (
                                                <MenuItem value={item.id} key={index}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Third Party :
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            value={thirdPartyID}
                                            onChange={(e) => setThirdPartyID(e.target.value)}
                                            // sx={{width:"100%"}}
                                        >
                                            <MenuItem value="">Select Third Party</MenuItem>
                                            {thirdPartyIDs.map((item, index) => (
                                                <MenuItem value={item.id} key={index}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Amount :
                                        </Typography>
                                        <input
                                            type="number"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={amount}
                                            onChange={(e) => setamount(e.target.value)}
                                        />
                                    </Box>
                                </Grid>

                                {/* <Grid item container xs={12} md={12} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Transaction Number :
                                        </Typography>
                                        <input
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={transactionNumber}
                                            onChange={(e) => setTransactionNumber(e.target.value)}
                                        />
                                    </Box>
                                </Grid>

                                
                                {DepositData.map((data, index) => (
                                        <>
                                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        Third Party :
                                                    </Typography>
                                                    <Select
                                                        displayEmpty
                                                        value={data.thirdPartyID}
                                                        onChange={(e) => handleInputChange(index, 'thirdPartyID', e.target.value)}
                                                    >
                                                        <MenuItem sx={{ width: '100%' }} value="">
                                                            Select Third Party
                                                        </MenuItem>
                                                        {thirdPartyIDs.map((item, index) => (
                                                            <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                                {item.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Box>
                                            </Grid>

                                            <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        Amount
                                                    </Typography>
                                                    <input
                                                        style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                        value={data.amount}
                                                        onChange={(e) => handleInputChange(index, 'amount', e.target.value)}
                                                        disabled={!data.thirdPartyID}
                                                        />
                                                </Box>
                                                {index === DepositData.length - 1 ? (
                                                    <button
                                                        type="button"
                                                        onClick={handleAddRow}
                                                        style={{ width: '10%', height: '50px', borderRadius: '10px', fontSize: '18px' }}
                                                        disabled={!data.thirdPartyID}
                                                    >
                                                        +
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeRow(index)}
                                                        style={{ width: '10%', height: '50px', borderRadius: '10px', fontSize: '18px' }}
                                                    >
                                                        🗑️
                                                    </button>
                                                )}
                                            </Grid>
                                        </>
                                    ))} */}
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => insertAddress()}
                            disabled={insertBtnDisabled}
                        >
                            Insert Deposit
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default InsertDepositRecord;

